<template>
    <Layout>
        <PageHeader :items="items" :title="title" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <!-- <div class="card-header text-right">
                        <a class="btn btn-sm btn-primary" download href="/assets/files/batch-import.xlsx">Batch Import Demo
                            File</a>
                        <b-button class="btn btn-sm btn-success ml-1" v-b-modal.modal-batch-import-modal>Import
                            Batch</b-button>
                    </div> -->
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-12">
                                <div v-show="show" class="alert alert-danger alert-dismissible fade show" role="alert">
                                    <span v-for="(err, index) in validation_errors" :key="index">
                                        {{ err[0] }} <br />
                                    </span>
                                </div>
                                <form>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label for="trainingTrade">Training Trade <span
                                                    class="c-required">*</span></label>
                                            <select v-model="batch.c_training_trade_id" v-validate="'required'"
                                                id="trainingTrade" name="c_training_trade_id"
                                                class="form-control form-control-sm">
                                                <option :value="''">Select Training Trade</option>
                                                <option v-for="(trade, index) in trades" :key="index" :value="trade.id">{{
                                                    trade.id }} : {{ trade.desc }}
                                                </option>
                                            </select>
                                            <div class="invalid-feedback">
                                                Please Select Training Trade
                                            </div>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for="trainingDuration">Training Duration <span
                                                    class="c-required">*</span></label>
                                            <select v-model="batch.c_training_duration_id" v-validate="'required'"
                                                id="trainingDuration" name="c_training_duration_id"
                                                class="form-control form-control-sm">
                                                <option :value="''">Select Training Duration</option>
                                                <option v-for="(duration, index) in durations" :key="index"
                                                    :value="duration.id">{{ duration.id }} : {{ duration.desc }}
                                                </option>
                                            </select>
                                            <div class="invalid-feedback">
                                                Please Select Duration
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label for="trainers">Trainers <span class="c-required">*</span></label>
                                            <multiselect v-model="batch.trainers" v-validate="'required'"
                                                :clear-on-select="false" :multiple="true" :options="all_trainers"
                                                :preselect-first="true" :preserve-search="true" label="desc" id="trainers"
                                                name="trainers" placeholder="Select Trainers" track-by="id"></multiselect>
                                            <!--                                            <div v-if="batch.trainers.length == 0" class="invalid-feedback">-->
                                            <!--                                                Please Select Trainers-->
                                            <!--                                            </div>-->
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for="c_training_venue_id">Venue <span class="c-required">*</span></label>
                                            <select v-model="batch.c_training_venue_id" v-validate="'required'"
                                                id="c_training_venue_id" name="c_training_venue_id"
                                                class="form-control form-control-sm">
                                                <option :value="''">Select Venue</option>
                                                <option v-for="(venue, index) in venues" :key="index" :value="venue.id">{{
                                                    venue.id }} : {{ venue.desc }}
                                                </option>
                                            </select>
                                            <div class="invalid-feedback">
                                                Please Select Venue
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label for="start_date">Start Date <span class="c-required">*</span></label>
                                            <input class="form-control form-control-sm" id="start_date"
                                                v-model="batch.start_date" type="datetime-local">

                                            <div class="text-danger" v-show="start_date_error">
                                                {{ start_date_error }}
                                            </div>

                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for="end_date">End Date <span class="c-required">*</span></label>
                                            <input class="form-control form-control-sm" v-model="batch.end_date"
                                                id="end_date" name="end_date" type="datetime-local">
                                            <div class="text-danger" v-show="end_date_error">
                                                {{ end_date_error }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label for="batch_no">Batch No. <span class="c-required">*</span></label>
                                            <select v-model="batch.batch_no" v-validate="'required'" id="batch_no"
                                                name="batch_no" class="form-control form-control-sm">
                                                <option :value="''">Select Batch no.</option>
                                                <option value="01">01</option>
                                                <option value="02">02</option>
                                                <option value="03">03</option>
                                                <option value="04">04</option>
                                                <option value="05">05</option>
                                                <option value="06">06</option>
                                                <option value="07">07</option>
                                                <option value="08">08</option>
                                                <option value="09">09</option>
                                                <option value="10">10</option>
                                                <option value="11">11</option>
                                                <option value="12">12</option>
                                                <option value="13">13</option>
                                                <option value="14">14</option>
                                                <option value="15">15</option>
                                                <option value="16">16</option>
                                                <option value="17">17</option>
                                                <option value="18">18</option>
                                                <option value="19">19</option>
                                                <option value="20">20</option>
                                                <option value="21">21</option>
                                                <option value="22">22</option>
                                                <option value="23">23</option>
                                                <option value="24">24</option>
                                                <option value="25">25</option>
                                            </select>
                                            <div class="invalid-feedback">
                                                Please Select Batch no.
                                            </div>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for="max_students">Class Size <span class="c-required">*</span></label>
                                            <input type="number" v-model="batch.max_students"
                                                v-validate="{ required: true, regex: /[0-9]+/ }" id="max_students"
                                                name="max_students" class="form-control form-control-sm"
                                                placeholder="Total Student of the Batch" />
                                            <div class="invalid-feedback">
                                                Please enter total student of the batch.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label for="trainee_conveyances">Trainee Conveyances <span
                                                    class="c-required">*</span></label>
                                            <input type="number" v-model="batch.trainee_conveyances"
                                                v-validate="{ required: true, regex: /^\d*[1-9]\d*$/ }"
                                                class="form-control form-control-sm" id="trainee_conveyances"
                                                name="trainee_conveyances" placeholder="Trainee Conveyances" />
                                            <div class="invalid-feedback">
                                                Please enter trainee conveyances.
                                            </div>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for="vat"> Vat on Apprentice<span class="c-required">*</span></label>
                                            <input type="number" v-model="batch.vat"
                                                v-validate="{ required: true, regex: /^[0-9]*(?:\.[0-9]{0,2})?$/ }" id="vat"
                                                name="vat" class="form-control form-control-sm" placeholder="Enter vat" />
                                            <div class="invalid-feedback">
                                                Please enter vat.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label for="tax"> Tax on Apprentice<span class="c-required">*</span></label>
                                            <input type="number" v-model="batch.tax"
                                                v-validate="{ required: true, regex: /^[0-9]*(?:\.[0-9]{0,2})?$/ }" id="tax"
                                                name="tax" class="form-control form-control-sm" placeholder="Enter tax" />
                                            <div class="invalid-feedback">
                                                Please enter tax.
                                            </div>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for="c_manage_id">Manage by <span class="c-required">*</span></label>
                                            <select v-model="batch.c_manage_id" v-validate="'required'" id="c_manage_id"
                                                name="c_manage_id" class="form-control form-control-sm">
                                                <option :value="''">Select Manage By</option>
                                                <option v-for="(manage_by, index) in manage_bys" :key="index"
                                                    :value="manage_by.id">{{ manage_by.id }} : {{ manage_by.desc }}
                                                </option>
                                            </select>
                                            <div class="invalid-feedback">
                                                Select manage by.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label for="c_training_pkg_id">Package <span class="c-required">*</span></label>
                                            <select v-model="batch.c_training_pkg_id" v-validate="'required'"
                                                id="c_training_pkg_id" name="c_training_pkg_id"
                                                class="form-control form-control-sm">
                                                <option :value="''">Select Package.</option>
                                                <option v-for="(pkgs, index) in packages" :key="index" :value="pkgs.id">{{
                                                    pkgs.id }} : {{ pkgs.desc }}
                                                </option>
                                            </select>
                                            <div class="invalid-feedback">
                                                Select package.
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="userPermission.includes('batch-create')" class="form-row">
                                        <div class="form-group col-md-6">
                                            <button class="btn btn-success waves-effect waves-light mr-2"
                                                @click.prevent="save">Save
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <BatchImportModal></BatchImportModal> -->
        </div>
    </Layout>
</template>

<script>
import moment from "moment";
import Multiselect from "vue-multiselect";

import appConfig from "@src/app.config";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";
// import BatchImportModal from './modal/batch-import-modal.vue'

export default {
    page: {
        title: "Create Batch",
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: { Layout, PageHeader, Multiselect },
    data() {
        return {
            title: "Create Batch",
            items: [
                {
                    text: 'Dashboard',
                    href: '/',
                },
                {
                    text: 'Batch',
                    href: '/batch/list',
                },
                {
                    text: 'Create',
                    active: true,
                },
            ],
            batch: {
                c_training_trade_id: "",
                c_training_duration_id: "",
                trainers: [],
                c_training_venue_id: "",
                max_students: "",
                trainee_conveyances: "",
                start_date: "",
                end_date: "",
                c_manage_id: "",
                batch_no: "",
                c_training_pkg_id: "",
                vat: "",
                tax: "",
            },
            trades: [],
            durations: [],
            all_trainers: [],
            venues: [],
            manage_bys: [],
            packages: [],
            validation_errors: {},
            show: false,
            start_date_error: '',
            end_date_error: '',
        };
    },

    mounted() {
        this.getTraineeToBatch();
    },

    methods: {
        customStartDate(date) {
            this.batch.start_date = moment(date).format("YYYY-MM-DD");
            return moment(date).format("YYYY-MM-DD");
        },
        customEndDate(date) {
            this.batch.end_date = moment(date).format("YYYY-MM-DD");
            return moment(date).format("YYYY-MM-DD");
        },
        save() {
            this.$validator.validate().then(valid => {
                if (valid) {
                    if (this.batch.start_date == '') {
                        this.start_date_error = 'Enter start date'
                        return;
                    }
                    if (this.batch.end_date == '') {
                        this.end_date_error = 'Enter end date'
                        return
                    }

                    http.post("api/batches", this.batch)
                        .then(response => {
                            if (!response.data.error) {
                                if (response.data.permissionError) {
                                    this.$bvToast.toast(response.data.permissionError, {
                                        title: "Error",
                                        autoHideDelay: 5000,
                                        variant: "danger"
                                    });
                                } else {
                                    this.$bvToast.toast(response.data.message, {
                                        title: "Success",
                                        autoHideDelay: 5000,
                                        variant: "success"
                                    });
                                    this.batch = "";
                                    this.$router.push("/batch/list/");
                                }
                            } else {
                                this.$bvToast.toast(response.data.message, {
                                    title: "Error",
                                    autoHideDelay: 5000,
                                    variant: "danger"
                                });
                            }
                        })
                        .catch(error => {
                            this.validation_errors = error.response.data.errors;
                            this.show = true;
                            this.hide();
                        });
                }
            });
        },
        getTraineeToBatch() {
            http
                .get("api/getTraineeToBatch")
                .then(response => {
                    this.trades = response.data.trades;
                    this.durations = response.data.durations;
                    this.all_trainers = response.data.trainers;
                    this.venues = response.data.venues;
                    this.manage_bys = response.data.manage_bys;
                    this.packages = response.data.packages;
                })
                .catch();
        },
        hide() {
            setTimeout(() => {
                this.show = false;
            }, 5000);
        }
    },

    computed: {
        userPermission() {
            return this.$store.state.user
        }
    },
    created() {
        this.$store.dispatch('getUserPermission')
    },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>